const category = {
  'module.category': '商品類別',
  'category.title.list': '商品類別',
  'category.title.add': '新增商品類別',
  'category.title.edit': '修改商品類別',
  'category.field.name': '名稱',
}

export default category
